import {
  Button,
  Slide,
  Snackbar,
} from "@material-ui/core";
import React, { useContext, useEffect, useRef, useState } from "react";
import { AuthContext } from "../../../context/authContext";
import Http from "../../../Http";
import ACCESS from "../../../ACCESS";

export default function GuiasEspeciales() {
  const ulineFileRef = useRef(null);
  const tremMFileRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const [SB, setSB] = useState({ open: false, msg: "" });

  // const [ulineOpen, setUlineOpen] = useState(false);
  const { hasAccess } = useContext(AuthContext);
  const [actions, setActions] = useState({
    uline: false,
  });

  useEffect(() => {
    actions.uline = hasAccess(ACCESS.GUIA.ARCHIVO_PRODUCTOS_ULINE);
    actions.tresm = hasAccess(ACCESS.GUIA.ARCHIVO_PRODUCTOS_3M);
    setActions({ ...actions });

    // eslint-disable-next-line
  }, []);


  const uline_uploadFile = () => {
    ulineFileRef.current.click();
  }

  const tresM_uploadFile = () => {
    tremMFileRef.current.click();
  }

  const uline_onFileUpload = async (e, type) => {
    let form = new FormData();
    form.append('type', type);
    form.append('file', e.target.files[0]);
    try {
      setIsLoading(true);
      let res = await Http.post(`productos/especiales`, form);
      if (!res.error) {
        setSB({ open: true, msg: 'Productos subidos' });
      }
      else {
        setSB({ open: true, msg: `Error: ${res.errMsg}` });
      }
      if (type === '3m') {
        tremMFileRef.current.value = null;
      } else {
        ulineFileRef.current.value = null;
      }
    } catch (error) {
      setSB({ open: true, msg: `Error: No se pudo guardar` });
    }
    setIsLoading(false);
  }

  return (
    <div>
      {actions.uline &&
        <div style={{ padding: 20 }}>
          <h2>Uline</h2>
          <Button disabled={isLoading} color='primary' variant='contained' onClick={uline_uploadFile}>Subir archivo (csv)</Button>
          <input type='file' hidden={true} ref={ulineFileRef} onChange={(e) => {uline_onFileUpload(e, 'uline')}} accept=".csv" />
        </div>
      }

      {actions.tresm &&
        <div style={{ padding: 20 }}>
          <h2>3M</h2>
          <Button disabled={isLoading} color='primary' variant='contained' onClick={uline_uploadFile}>Subir archivo (csv)</Button>
          <input type='file' hidden={true} ref={tremMFileRef} onChange={(e) => {tresM_uploadFile(e, '3m')}} accept=".csv" />
        </div>
      }

      <Snackbar
        open={SB.open}
        onClose={() => {
          setSB({ open: false });
        }}
        TransitionComponent={Slide}
        message={<span id="message-id">{SB.msg}</span>}
      />
    </div>
  );
}
